import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Vaata kõiki

  <span style="color:#85c1dc;">**FI:**</span>
  Katso kaikki

  <span style="color:#85c1dc;">**RU:**</span>
  Смотреть все
*/
/* @__NO_SIDE_EFFECTS__ */
const m459 = msg(
  mf`Vaata kõiki`,
  mf`Katso kaikki`,
  mf`Смотреть все`,
)

export { m459 as 'w.search.view-all' }